import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export enum ModalType {
  INSERTGAME = 'insert-game',
  INSCRIBE = 'inscribe',
  HELP = 'help',
}
export enum GameModalType {
  QUITGAME = 'quit-game'
}

export enum UIMode {
  PLAYER = 'player',
  DEVELOPER = 'developer'
}

interface IUi {
  sound: boolean;
  mode: UIMode;
  modal?: ModalType;
  gameModal?: GameModalType;
}

const initialPreferences = () => {
  const savedPref = localStorage.getItem('wowboi-sound');

  if (savedPref) {
    return savedPref === 'on' ? true : false;
  } else return true
}

const initialState: IUi = {
  sound: initialPreferences(),
  mode: UIMode.PLAYER
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSound: (state, action: PayloadAction<boolean>) => {
      state.sound = action.payload;
    },
    setMode: (state, action: PayloadAction<UIMode>) => {
      state.mode = action.payload;
    },
    setModal: (state, action: PayloadAction<ModalType | undefined>) => {
      state.modal = action.payload
    },
    setGameModal: (state, action: PayloadAction<GameModalType | undefined>) => {
      state.gameModal = action.payload
    }
  },
})

export const { setSound, setMode, setModal, setGameModal } = uiSlice.actions

export default uiSlice.reducer